import {
  GET_ADDRESS_REQUEST,
  GET_ADDRESS_SUCCESS,
  GET_ADDRESS_FAILURE,
  GET_ERROR_ADDRESS_REQUEST,
  GET_ERROR_ADDRESS_SUCCESS,
  GET_ERROR_ADDRESS_FAILURE,
  GET_WARNING_ADDRESS_REQUEST,
  GET_WARNING_ADDRESS_SUCCESS,
  GET_WARNING_ADDRESS_FAILURE,
  GET_SEND_ADDRESSES_CONFIRM_REQUEST,
  GET_SEND_ADDRESSES_CONFIRM_SUCCESS,
  GET_SEND_ADDRESSES_CONFIRM_FAILURE,
  GET_ORDERED_FOLLOW_CALL_CONFIRM_REQUEST,
  GET_ORDERED_FOLLOW_CALL_CONFIRM_SUCCESS,
  GET_ORDERED_FOLLOW_CALL_CONFIRM_FAILURE,
  POST_ADDRESS_REQUEST,
  POST_ADDRESS_SUCCESS,
  POST_ADDRESS_FAILURE,
  POST_EXCEL_CONTACTS_REQUEST,
  POST_EXCEL_CONTACTS_SUCCESS,
  POST_EXCEL_CONTACTS_FAILURE,
  PATCH_CONTACTS_REQUEST,
  PATCH_CONTACTS_SUCCESS,
  PATCH_CONTACTS_FAILURE,
  DELETE_ADDRESS_MULTI_REQUEST,
  DELETE_ADDRESS_MULTI_SUCCESS,
  DELETE_ADDRESS_MULTI_FAILURE,
  PUT_ADDRESS_TAGS_MULTI_REQUEST,
  PUT_ADDRESS_TAGS_MULTI_SUCCESS,
  PUT_ADDRESS_TAGS_MULTI_FAILURE,
  DELETE_ERROR_ADDRESS_MULTI_REQUEST,
  DELETE_ERROR_ADDRESS_MULTI_SUCCESS,
  DELETE_ERROR_ADDRESS_MULTI_FAILURE,
  DELETE_WARNING_ADDRESS_MULTI_REQUEST,
  DELETE_WARNING_ADDRESS_MULTI_SUCCESS,
  DELETE_WARNING_ADDRESS_MULTI_FAILURE,
  POST_ERROR_ADDRESS_REQUEST,
  POST_ERROR_ADDRESS_SUCCESS,
  POST_ERROR_ADDRESS_FAILURE,
  POST_WARNING_ADDRESSES_REQUEST,
  POST_WARNING_ADDRESSES_SUCCESS,
  POST_WARNING_ADDRESSES_FAILURE,
  POST_WARNING_ADDRESSES_RESTORE_REQUEST,
  POST_WARNING_ADDRESSES_RESTORE_SUCCESS,
  POST_WARNING_ADDRESSES_RESTORE_FAILURE,
  CLEAR_ADDRESS_DATA,
  GET_ADDRESS_TAGS_REQUEST,
  GET_ADDRESS_TAGS_SUCCESS,
  GET_ADDRESS_TAGS_FAILURE,
  DELETE_WARNING_ADDRESS_BY_ID_REQUEST,
  DELETE_WARNING_ADDRESS_BY_ID_SUCCESS,
  DELETE_WARNING_ADDRESS_BY_ID_FAILURE,
  DELETE_ERROR_ADDRESS_BY_ID_REQUEST,
  DELETE_ERROR_ADDRESS_BY_ID_SUCCESS,
  DELETE_ERROR_ADDRESS_BY_ID_FAILURE,
  GET_ADDRESS_SUGGEST_CORP_REQUEST,
  GET_ADDRESS_SUGGEST_CORP_SUCCESS,
  GET_ADDRESS_SUGGEST_CORP_FAILURE,
  GET_FAILED_LINK_ADDRESS_REQUEST,
  GET_FAILED_LINK_ADDRESS_SUCCESS,
  GET_FAILED_LINK_ADDRESS_FAILURE,
  PUT_ADDRESS_LINK_CORPORATION_REQUEST,
  PUT_ADDRESS_LINK_CORPORATION_SUCCESS,
  PUT_ADDRESS_LINK_CORPORATION_FAILURE,
  POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_REQUEST,
  POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_SUCCESS,
  POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_FAILURE,
  POST_WARNING_ADDRESSES_OVERWRITE_REQUEST,
  POST_WARNING_ADDRESSES_OVERWRITE_SUCCESS,
  POST_WARNING_ADDRESSES_OVERWRITE_FAILURE,
  GET_ADDRESS_TOTALS_REQUEST,
  GET_ADDRESS_TOTALS_SUCCESS,
  GET_ADDRESS_TOTALS_FAILURE,
  GET_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST,
  GET_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS,
  GET_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE,
  GET_WARNING_ADDRESS_TAGS_REQUEST,
  GET_WARNING_ADDRESS_TAGS_SUCCESS,
  GET_WARNING_ADDRESS_TAGS_FAILURE,
  GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST,
  GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS,
  GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE,
  GET_ERROR_ADDRESS_TAGS_REQUEST,
  GET_ERROR_ADDRESS_TAGS_SUCCESS,
  GET_ERROR_ADDRESS_TAGS_FAILURE,
  GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST,
  GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS,
  GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE,
  POST_ADDRESSES_MOVE_NG_SENDINGS_REQUEST,
  POST_ADDRESSES_MOVE_NG_SENDINGS_SUCCESS,
  POST_ADDRESSES_MOVE_NG_SENDINGS_FAILURE,
  POST_ADDRESSES_RESTORE_NG_SENDINGS_REQUEST,
  POST_ADDRESSES_RESTORE_NG_SENDINGS_SUCCESS,
  POST_ADDRESSES_RESTORE_NG_SENDINGS_FAILURE,
  GET_WARNING_ADDRESS_SUGGEST_CORP_REQUEST,
  GET_WARNING_ADDRESS_SUGGEST_CORP_SUCCESS,
  GET_WARNING_ADDRESS_SUGGEST_CORP_FAILURE,
  GET_ERROR_ADDRESS_SUGGEST_CORP_REQUEST,
  GET_ERROR_ADDRESS_SUGGEST_CORP_SUCCESS,
  GET_ERROR_ADDRESS_SUGGEST_CORP_FAILURE,
  GET_EXECUTIVE_LIST_COUNT_REQUEST,
  GET_EXECUTIVE_LIST_COUNT_SUCCESS,
  GET_EXECUTIVE_LIST_COUNT_FAILURE,
  PUT_ADDRESSES_TAGS_DELETEMULTI_REQUEST,
  PUT_ADDRESSES_TAGS_DELETEMULTI_SUCCESS,
  PUT_ADDRESSES_TAGS_DELETEMULTI_FAILURE,
  PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST,
  PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS,
  PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE,
  PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_REQUEST,
  PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_SUCCESS,
  PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_FAILURE,
  PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST,
  PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS,
  PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE,
  PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_REQUEST,
  PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_SUCCESS,
  PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_FAILURE,
  PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST,
  PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS,
  PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE,
  POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_REQUEST,
  POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_SUCCESS,
  POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_FAILURE,
  GET_ADDRESS_CORPORATION_DIFFERENCES_COUNT_REQUEST,
  GET_ADDRESS_CORPORATION_DIFFERENCES_COUNT_SUCCESS,
  GET_ADDRESS_CORPORATION_DIFFERENCES_COUNT_FAILURE,
  POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_REQUEST,
  POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_SUCCESS,
  POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_FAILURE,
  POST_WARNING_ADDRESSES_OVERWRITEMULTI_REQUEST,
  POST_WARNING_ADDRESSES_OVERWRITEMULTI_SUCCESS,
  POST_WARNING_ADDRESSES_OVERWRITEMULTI_FAILURE,
  POST_WARNING_ADDRESSES_MULTI_REQUEST,
  POST_WARNING_ADDRESSES_MULTI_SUCCESS,
  POST_WARNING_ADDRESSES_MULTI_FAILURE,
  POST_ADDRESS_LIST_SALESFORCE_SYNC_REQUEST,
  POST_ADDRESS_LIST_SALESFORCE_SYNC_SUCCESS,
  POST_ADDRESS_LIST_SALESFORCE_SYNC_FAILURE,
  STORE_FILTER_VALUE,
} from '../../constants/ActionTypes'
import { AddressBookApi } from '../api/AddressBookApi';
import { NgSendingsApi } from '../api/NgSendingsApi';
import { ExecutiveListApi } from '../api/ExecutiveListApi';
import { AddressCorporationDifferencesApi } from '../api/AddressCorporationDifferencesApi';
import { postMultiPostcodes, postMultiPostcodesFailure } from './Postcode'
import { TagType, SortType, AddressBookTab } from '../../constants/ComponentTypes'
import { ADDRESS_PER_PAGE } from '../../constants/Constants'

/*** GET /address ***/

const getAddressRequest = (tab, overwrite) => ({
  type: GET_ADDRESS_REQUEST,
  payload: {
    tab: tab,
    overwrite: overwrite,
  }
});

const getAddressSuccess = (contacts, pageInfo, tab, overwrite) => ({
  type: GET_ADDRESS_SUCCESS,
  payload: {
    contacts: contacts,
    pageInfo: pageInfo,
    tab: tab,
    overwrite: overwrite,
  }
});

const getAddressFailure = (error, tab) => ({
  type: GET_ADDRESS_FAILURE,
  payload: {
    error: error,
    tab: tab,
  }
});

export function getAddress(data, tab, overwrite = false) {
  return async (dispatch) => {
    dispatch(getAddressRequest(tab, overwrite));

    AddressBookApi.getAddress(data, dispatch)
      .then((response) => {
        dispatch(getAddressSuccess(
          response.data.data,
          response.data.meta,
          tab,
          overwrite
        ));
      })
      .catch((error) => {
        dispatch(getAddressFailure(error.response, tab));
      });
  };
}

export function getAddressesDemo(data, overwrite = false) {
  return async (dispatch) => {
    dispatch(getAddressRequest(AddressBookTab.ALL, overwrite));

    AddressBookApi.getAddressesDemo(data, dispatch)
      .then((response) => {
        dispatch(getAddressSuccess(
          response.data.data,
          response.data.meta,
          AddressBookTab.ALL,
          overwrite
        ));
      })
      .catch((error) => {
        dispatch(getAddressFailure(error.response, AddressBookTab.ALL));
      });
  };
}

/*** POST /address - excel upload ***/

const postExcelContactsRequest = () => ({
  type: POST_EXCEL_CONTACTS_REQUEST,
});

const postExcelContactsSuccess = (items) => ({
  type: POST_EXCEL_CONTACTS_SUCCESS,
  payload: {
    items: items,
  }
});

const postExcelContactsFailure = (error) => ({
  type: POST_EXCEL_CONTACTS_FAILURE,
  payload: {
    error: error
  }
});

export function addItemsFromExcel(items) {
  return async (dispatch) => {
    dispatch(postExcelContactsRequest());

    AddressBookApi.postAddress(items, dispatch).then((response) => {
      dispatch(postExcelContactsSuccess(response.data.data));
    }).catch((error) => {
      dispatch(postExcelContactsFailure(error.response));
    });
  }
}

/*** POST /address - manual input ***/

const postAddressRequest = () => ({
  type: POST_ADDRESS_REQUEST,
});

const postAddressSuccess = (items) => ({
  type: POST_ADDRESS_SUCCESS,
  payload: {
    items: items,
  }
});

const postAddressFailure = (error) => ({
  type: POST_ADDRESS_FAILURE,
  payload: {
    error: error
  }
});

export function addItems(items) {
  return async (dispatch) => {
    dispatch(postAddressRequest());

    AddressBookApi.postAddress(items, dispatch).then((response) => {
      dispatch(postAddressSuccess(response.data.data));
    }).catch((error) => {
      dispatch(postAddressFailure(error.response));
    });
  }
}

export function validatePostcodeAndAddItems(data) {
  return (dispatch) => {
    let postcodes = data["addresses"].map(item => item.post_code);

    return dispatch(postMultiPostcodes(postcodes))
      .then(() => {
        dispatch(addItems(data));
      })
      .catch((error) => {
        dispatch(postMultiPostcodesFailure(error));
        if (Array.isArray(error)) {
          let validItems = [];
          for (let i = 0; i < error.length; i++) {
            // if the item has no error, a
            if (Object.keys(error[i]).length === 0) {
              validItems.push(data["addresses"][i]);
            }
          }

          if (validItems.length > 0) {
            dispatch(addItems(validItems));
          }
        }
      })
  }
}

/*** GET /addresses/confirm/send_addresses ***/
const getSendAddressesConfirmRequest = () => ({
  type: GET_SEND_ADDRESSES_CONFIRM_REQUEST,
});

const getSendAddressesConfirmSuccess = (hasLetterOrderHistoryNames, duplicateNames, selectAddress) => ({
  type: GET_SEND_ADDRESSES_CONFIRM_SUCCESS,
  payload: {
    hasLetterOrderHistoryNames: hasLetterOrderHistoryNames,
    duplicateNames: duplicateNames,
    selectAddress: selectAddress,
  },
});

const getSendAddressesConfirmFailure = (error) => ({
  type: GET_SEND_ADDRESSES_CONFIRM_FAILURE,
  payload: {
    error: error,
  }
});

export function getSendAddressesConfirm(data) {
  return async (dispatch) => {
    dispatch(getSendAddressesConfirmRequest());

    AddressBookApi.getSendAddressesConfirm(data, dispatch)
      .then((response) => {
        dispatch(getSendAddressesConfirmSuccess(
          response.data.has_letter_order_history_names,
          response.data.duplicate_names,
          response.data.select_address
        ));
      })
      .catch((error) => {
        dispatch(getSendAddressesConfirmFailure(error.response));
      });
  };
}

/*** GET /addresses/confirm/send_addresses ***/
const getOrderedFollowCallConfirmRequest = () => ({
  type: GET_ORDERED_FOLLOW_CALL_CONFIRM_REQUEST,
});

const getOrderedFollowCallConfirmSuccess = (names, selectAddress) => ({
  type: GET_ORDERED_FOLLOW_CALL_CONFIRM_SUCCESS,
  payload: {
    names: names,
    selectAddress: selectAddress,
  },
});

const getOrderedFollowCallConfirmFailure = (error) => ({
  type: GET_ORDERED_FOLLOW_CALL_CONFIRM_FAILURE,
  payload: {
    error: error,
  }
});

export function getOrderedFollowCallConfirm(data) {
  return async (dispatch) => {
    dispatch(getOrderedFollowCallConfirmRequest());

    AddressBookApi.getOrderedFollowCallConfirm(data, dispatch)
      .then((response) => {
        dispatch(getOrderedFollowCallConfirmSuccess(response.data.data, response.data.select_address));
      })
      .catch((error) => {
        dispatch(getOrderedFollowCallConfirmFailure(error.response));
      });
  };
}

/*** PATCH /address  ***/

const patchContactRequest = () => ({
  type: PATCH_CONTACTS_REQUEST,
});

const patchContactSuccess = (editedItems) => ({
  type: PATCH_CONTACTS_SUCCESS,
  payload: {
    edited: editedItems,
  }
});

const patchContactFailure = (error) => ({
  type: PATCH_CONTACTS_FAILURE,
  payload: {
    error: error
  }
});

export function editItems(editedItems) {
  return async (dispatch) => {
    dispatch(patchContactRequest());

    AddressBookApi.patchAddressById(editedItems[0], dispatch).then((response) => {
      dispatch(patchContactSuccess(response.data.data));
    }).catch((error) => {
      dispatch(patchContactFailure(error.response));
    });
  }
}

/*** DELETE /address  ***/

const deleteAddressMultiRequest = () => ({
  type: DELETE_ADDRESS_MULTI_REQUEST,
});

const deleteAddressMultiSuccess = (address_ids, except_address_ids, message) => ({
  type: DELETE_ADDRESS_MULTI_SUCCESS,
  payload: {
    ids: address_ids,
    exceptIds: except_address_ids,
    message: message
  }
});

const deleteAddressMultiFailure = (error) => ({
  type: DELETE_ADDRESS_MULTI_FAILURE,
  payload: {
    error: error
  }
});

export function deleteAddressMulti(query) {
  return async (dispatch) => {
    dispatch(deleteAddressMultiRequest());

    AddressBookApi.deleteAddress(query, dispatch)
      .then((response) => {
        dispatch(deleteAddressMultiSuccess(query.address_ids, query.except_address_ids, response.data.message));
      })
      .catch((error) => {
        dispatch(deleteAddressMultiFailure(error.response));
      });
  };
}

/*** PUT /addresses/tags/updateMulti  ***/

const putAddressTagMultiRequest = () => ({
  type: PUT_ADDRESS_TAGS_MULTI_REQUEST,
});

const putAddressTagMultiSuccess = (tags, address_ids, except_address_ids) => ({
  type: PUT_ADDRESS_TAGS_MULTI_SUCCESS,
  payload: {
    tags: tags,
    ids: address_ids,
    exceptIds: except_address_ids,
  }
});

const putAddressTagMultiFailure = (error) => ({
  type: PUT_ADDRESS_TAGS_MULTI_FAILURE,
  payload: {
    error: error
  }
});

export function putAddressTagMulti(data) {
  return async (dispatch) => {
    dispatch(putAddressTagMultiRequest());

    AddressBookApi.putAddressTagMulti(data, dispatch)
      .then(() => {
        dispatch(putAddressTagMultiSuccess(data.tags, data.address_ids, data.except_address_ids));
      })
      .catch((error) => {
        dispatch(putAddressTagMultiFailure(error.response));
      });
  };
}

/*** GET /error-addresses  ***/
const getErrorAddressRequest = (overwrite) => ({
  type: GET_ERROR_ADDRESS_REQUEST,
  payload: {
    overwrite: overwrite,
  }
})

const getErrorAddressSuccess = (contacts, pageInfo, overwrite) => ({
  type: GET_ERROR_ADDRESS_SUCCESS,
  payload: {
    contacts: contacts,
    pageInfo: pageInfo,
    overwrite: overwrite,
  }
})

const getErrorAddressFailure = (error) => ({
  type: GET_ERROR_ADDRESS_FAILURE,
  payload: {
    error: error
  }
})

export const getErrorAddress = (data, overwrite = false) => {
  return async (dispatch) => {
    dispatch(getErrorAddressRequest(overwrite));

    AddressBookApi.getErrorAddress(data, dispatch)
      .then((response) => {
        dispatch(getErrorAddressSuccess(response.data.data, response.data.meta, overwrite));
      })
      .catch((error) => {
        dispatch(getErrorAddressFailure(error.response));
      });
  }
}

/*** GET /warning-addresses  ***/
const getWarningAddressRequest = (overwrite) => ({
  type: GET_WARNING_ADDRESS_REQUEST,
  payload: {
    overwrite: overwrite
  }
})

const getWarningAddressSuccess = (contacts, pageInfo, overwrite) => ({
  type: GET_WARNING_ADDRESS_SUCCESS,
  payload: {
    contacts: contacts,
    pageInfo: pageInfo,
    overwrite: overwrite
  }
})

const getWarningAddressFailure = (error) => ({
  type: GET_WARNING_ADDRESS_FAILURE,
  payload: {
    error: error
  }
})

export const getWarningAddress = (data, overwrite = false) => {
  return async (dispatch) => {
    dispatch(getWarningAddressRequest(overwrite));

    AddressBookApi.getWarningAddress(data, dispatch)
      .then((response) => {
        dispatch(getWarningAddressSuccess(response.data.data, response.data.meta, overwrite));
      })
      .catch((error) => {
        dispatch(getWarningAddressFailure(error.response));
      });
  }
}

/*** POST /error-addresses/deleteMulti ***/
const deleteErrorAddressMultiRequest = () => ({
  type: DELETE_ERROR_ADDRESS_MULTI_REQUEST,
})

const deleteErrorAddressMultiSuccess = (error_address_ids, except_error_address_ids, message) => ({
  type: DELETE_ERROR_ADDRESS_MULTI_SUCCESS,
  payload: {
    error_address_ids: error_address_ids,
    except_error_address_ids: except_error_address_ids,
    message: message,
  }
})

const deleteErrorAddressMultiFailure = (error) => ({
  type: DELETE_ERROR_ADDRESS_MULTI_FAILURE,
  payload: {
    error: error
  }
})

export const deleteErrorAddressMulti = (data) => {
  return async (dispatch) => {
    dispatch(deleteErrorAddressMultiRequest());

    AddressBookApi.deleteErrorAddressMulti(data, dispatch)
      .then((response) => {
        const { error_address_ids, except_error_address_ids, ...rest } = data;

        dispatch(deleteErrorAddressMultiSuccess(error_address_ids, except_error_address_ids, response.data.message));
        dispatch(getErrorAddress({ ...rest, 'paging': 1, 'page': 1, 'per_page': ADDRESS_PER_PAGE }, true));
      })
      .catch((error) => {
        dispatch(deleteErrorAddressMultiFailure(error.response));
      });
  };
}

/*** DELETE /error-addresses/{id}  ***/
const deleteErrorAddressByIdRequest = () => ({
  type: DELETE_ERROR_ADDRESS_BY_ID_REQUEST,
});

const deleteErrorAddressByIdSuccess = (id) => ({
  type: DELETE_ERROR_ADDRESS_BY_ID_SUCCESS,
  payload: {
    id: id,
  }
});

const deleteErrorAddressByIdFailure = (error) => ({
  type: DELETE_ERROR_ADDRESS_BY_ID_FAILURE,
  payload: {
    error: error
  }
});

export function deleteErrorAddressById(id) {
  return async (dispatch) => {
    dispatch(deleteErrorAddressByIdRequest());

    AddressBookApi.deleteErrorAddressById(id, dispatch)
      .then(() => {
        dispatch(deleteErrorAddressByIdSuccess(id));
      })
      .catch((error) => {
        dispatch(deleteErrorAddressByIdFailure(error.response));
      });
  };
}

/*** DELETE /warning-addresses/{id}  ***/
const deleteWarningAddressByIdRequest = () => ({
  type: DELETE_WARNING_ADDRESS_BY_ID_REQUEST,
});

const deleteWarningAddressByIdSuccess = (id) => ({
  type: DELETE_WARNING_ADDRESS_BY_ID_SUCCESS,
  payload: {
    id: id,
  }
});

const deleteWarningAddressByIdFailure = (error) => ({
  type: DELETE_WARNING_ADDRESS_BY_ID_FAILURE,
  payload: {
    error: error
  }
});

export function deleteWarningAddressById(id) {
  return async (dispatch) => {
    dispatch(deleteWarningAddressByIdRequest());

    AddressBookApi.deleteWarningAddressById(id, dispatch)
      .then(() => {
        dispatch(deleteWarningAddressByIdSuccess(id));
      })
      .catch((error) => {
        dispatch(deleteWarningAddressByIdFailure(error.response));
      });
  };
}


/*** POST /warning-addresses/deleteMulti ***/
const deleteWarningAddressMultiRequest = () => ({
  type: DELETE_WARNING_ADDRESS_MULTI_REQUEST,
})

const deleteWarningAddressMultiSuccess = (warning_address_ids, except_warning_address_ids, message) => ({
  type: DELETE_WARNING_ADDRESS_MULTI_SUCCESS,
  payload: {
    warning_address_ids: warning_address_ids,
    except_warning_address_ids: except_warning_address_ids,
    message: message,
  }
})

const deleteWarningAddressMultiFailure = (error) => ({
  type: DELETE_WARNING_ADDRESS_MULTI_FAILURE,
  payload: {
    error: error
  }
})

export const deleteWarningAddressMulti = (data) => {
  return async (dispatch) => {
    dispatch(deleteWarningAddressMultiRequest());

    AddressBookApi.deleteWarningAddressMulti(data, dispatch)
      .then((response) => {
        const { warning_address_ids, except_warning_address_ids, ...rest } = data;

        dispatch(deleteWarningAddressMultiSuccess(warning_address_ids, except_warning_address_ids, response.data.message));
        dispatch(getWarningAddress({ ...rest, 'paging': 1, 'page': 1, 'per_page': ADDRESS_PER_PAGE }, true));
      })
      .catch((error) => {
        dispatch(deleteWarningAddressMultiFailure(error.response));
      });
  };
}

/*** POST /error-addresses/{id} ***/
const postErrorAddressRequest = () => ({
  type: POST_ERROR_ADDRESS_REQUEST,
});

const postErrorAddressSuccess = (item, errorId) => ({
  type: POST_ERROR_ADDRESS_SUCCESS,
  payload: {
    item: item,
    errorId: errorId,
  }
});

const postErrorAddressFailure = (error, errorId) => ({
  type: POST_ERROR_ADDRESS_FAILURE,
  payload: {
    error: error,
    errorId: errorId,
  }
});

export function postErrorAddress(item) {
  return async (dispatch) => {
    dispatch(postErrorAddressRequest());

    AddressBookApi.postErrorAddress(item, dispatch).then((response) => {
      dispatch(postErrorAddressSuccess(response.data.data, item.id));
    }).catch((error) => {
      dispatch(postErrorAddressFailure(error.response, item.id));
    });
  }
}

/*** POST /warning-addresses/{id} ***/
const postWarningAddressRequest = () => ({
  type: POST_WARNING_ADDRESSES_REQUEST,
});

const postWarningAddressSuccess = (item, warningId) => ({
  type: POST_WARNING_ADDRESSES_SUCCESS,
  payload: {
    item: item,
    warningId: warningId,
  }
});

const postWarningAddressFailure = (error, warningId) => ({
  type: POST_WARNING_ADDRESSES_FAILURE,
  payload: {
    error: error,
    warningId: warningId,
  }
});

export function postWarningAddress(item) {
  return async (dispatch) => {
    dispatch(postWarningAddressRequest());

    AddressBookApi.postWarningAddress(item, dispatch).then((response) => {
      dispatch(postWarningAddressSuccess(response.data.data, item.id));
    }).catch((error) => {
      dispatch(postWarningAddressFailure(error.response, item.id));
    });
  }
}

/*** POST /warning-addresses/{id}/restore ***/
const postWarningAddressRestoreRequest = () => ({
  type: POST_WARNING_ADDRESSES_RESTORE_REQUEST,
});

const postWarningAddressRestoreSuccess = () => ({
  type: POST_WARNING_ADDRESSES_RESTORE_SUCCESS,
});

const postWarningAddressRestoreFailure = (error, warningId) => ({
  type: POST_WARNING_ADDRESSES_RESTORE_FAILURE,
  payload: {
    error: error,
    warningId: warningId,
  }
});

export function postWarningAddressRestore(item) {
  return async (dispatch) => {
    dispatch(postWarningAddressRestoreRequest());

    AddressBookApi.postWarningAddressRestore({ id: item.id }, dispatch)
      .then(() => {
        dispatch(postWarningAddressRestoreSuccess());
      }).catch((error) => {
        dispatch(postWarningAddressRestoreFailure(error.response, item.id));
      });
  }
}

/*** clear address data ***/
export const clearAddressData = (tab) => ({
  type: CLEAR_ADDRESS_DATA,
  payload: {
    tab: tab,
  }
})

/*** GET /addresses/tags ***/
const getAddressTagsRequest = (isAllTags, overwrite) => ({
  type: GET_ADDRESS_TAGS_REQUEST,
  payload: {
    isAllTags: isAllTags,
    overwrite: overwrite,
  }
});

const getAddressTagsSuccess = (tags, isAllTags) => ({
  type: GET_ADDRESS_TAGS_SUCCESS,
  payload: {
    tags: tags,
    isAllTags: isAllTags,
  }
});

const getAddressTagsFailure = (error, isAllTags) => ({
  type: GET_ADDRESS_TAGS_FAILURE,
  payload: {
    error: error,
    isAllTags: isAllTags
  }
});

export function getAddressTags(data = {}, isAllTags = true, overwrite = true) {
  return async (dispatch) => {
    dispatch(getAddressTagsRequest(isAllTags, overwrite));

    AddressBookApi.getAddressTags({ ...data, "type": [TagType.CUSTOM_TAG] }, dispatch)
      .then((response) => {
        dispatch(getAddressTagsSuccess(
          response.data.data,
          isAllTags
        ));
      })
      .catch((error) => {
        dispatch(getAddressTagsFailure(error.response, isAllTags));
      });
  };
}

/*** GET /addresses/tags ***/
const getAddressImportHistoryTagsRequest = () => ({
  type: GET_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST,
});

const getAddressImportHistoryTagsSuccess = (tags) => ({
  type: GET_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS,
  payload: {
    tags: tags,
  }
});

const getAddressImportHistoryTagsFailure = (error) => ({
  type: GET_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE,
  payload: {
    error: error,
  }
});

export function getAddressImportHistoryTags() {
  return async (dispatch) => {
    dispatch(getAddressImportHistoryTagsRequest());

    AddressBookApi.getAddressTags({ "type": [TagType.IMPORT_HISTORY], "sort_type": SortType.SORT_TYPE_TAG_NAME_DESC }, dispatch)
      .then((response) => {
        dispatch(getAddressImportHistoryTagsSuccess(
          response.data.data,
        ));
      })
      .catch((error) => {
        dispatch(getAddressImportHistoryTagsFailure(error.response));
      });
  };
}

/*** GET /warning-addresses/tags ***/
const getWarningAddressTagsRequest = () => ({
  type: GET_WARNING_ADDRESS_TAGS_REQUEST,
});

const getWarningAddressTagsSuccess = (tags) => ({
  type: GET_WARNING_ADDRESS_TAGS_SUCCESS,
  payload: {
    tags: tags,
  }
});

const getWarningAddressTagsFailure = (error) => ({
  type: GET_WARNING_ADDRESS_TAGS_FAILURE,
  payload: {
    error: error,
  }
});

export function getWarningAddressTags() {
  return async (dispatch) => {
    dispatch(getWarningAddressTagsRequest());

    AddressBookApi.getWarningAddressTags({ "type": [TagType.CUSTOM_TAG] }, dispatch)
      .then((response) => {
        dispatch(getWarningAddressTagsSuccess(
          response.data.data,
        ));
      })
      .catch((error) => {
        dispatch(getWarningAddressTagsFailure(error.response));
      });
  };
}

/*** GET /warning-addresses/tags ***/
const getWarningAddressImportHistoryTagsRequest = () => ({
  type: GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST,
});

const getWarningAddressImportHistoryTagsSuccess = (tags) => ({
  type: GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS,
  payload: {
    tags: tags,
  }
});

const getWarningAddressImportHistoryTagsFailure = (error) => ({
  type: GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE,
  payload: {
    error: error,
  }
});

export function getWarningAddressImportHistoryTags() {
  return async (dispatch) => {
    dispatch(getWarningAddressImportHistoryTagsRequest());

    AddressBookApi.getWarningAddressTags({ "type": [TagType.IMPORT_HISTORY], "sort_type": SortType.SORT_TYPE_TAG_NAME_DESC }, dispatch)
      .then((response) => {
        dispatch(getWarningAddressImportHistoryTagsSuccess(
          response.data.data,
        ));
      })
      .catch((error) => {
        dispatch(getWarningAddressImportHistoryTagsFailure(error.response));
      });
  };
}

/*** GET /error-addresses/tags ***/
const getErrorAddressTagsRequest = () => ({
  type: GET_ERROR_ADDRESS_TAGS_REQUEST,
});

const getErrorAddressTagsSuccess = (tags) => ({
  type: GET_ERROR_ADDRESS_TAGS_SUCCESS,
  payload: {
    tags: tags,
  }
});

const getErrorAddressTagsFailure = (error) => ({
  type: GET_ERROR_ADDRESS_TAGS_FAILURE,
  payload: {
    error: error,
  }
});

export function getErrorAddressTags() {
  return async (dispatch) => {
    dispatch(getErrorAddressTagsRequest());

    AddressBookApi.getErrorAddressTags({ "type": [TagType.CUSTOM_TAG] }, dispatch)
      .then((response) => {
        dispatch(getErrorAddressTagsSuccess(
          response.data.data,
        ));
      })
      .catch((error) => {
        dispatch(getErrorAddressTagsFailure(error.response));
      });
  };
}

/*** GET /error-addresses/tags ***/
const getErrorAddressImportHistoryTagsRequest = () => ({
  type: GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST,
});

const getErrorAddressImportHistoryTagsSuccess = (tags) => ({
  type: GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS,
  payload: {
    tags: tags,
  }
});

const getErrorAddressImportHistoryTagsFailure = (error) => ({
  type: GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE,
  payload: {
    error: error,
  }
});

export function getErrorAddressImportHistoryTags() {
  return async (dispatch) => {
    dispatch(getErrorAddressImportHistoryTagsRequest());

    AddressBookApi.getErrorAddressTags({ "type": [TagType.IMPORT_HISTORY], "sort_type": SortType.SORT_TYPE_TAG_NAME_DESC }, dispatch)
      .then((response) => {
        dispatch(getErrorAddressImportHistoryTagsSuccess(
          response.data.data,
        ));
      })
      .catch((error) => {
        dispatch(getErrorAddressImportHistoryTagsFailure(error.response));
      });
  };
}

/*** GET /addresses/id/suggest-corporations ***/
const getAddressSuggestCorporationsRequest = () => ({
  type: GET_ADDRESS_SUGGEST_CORP_REQUEST,
});

const getAddressSuggestCorporationsSuccess = (corporations) => ({
  type: GET_ADDRESS_SUGGEST_CORP_SUCCESS,
  payload: {
    corporations: corporations
  }
});

const getAddressSuggestCorporationsFailure = (error) => ({
  type: GET_ADDRESS_SUGGEST_CORP_FAILURE,
  payload: {
    error: error,
  }
});

export function getAddressSuggestCorporations(id, data = {}) {
  return async (dispatch) => {
    dispatch(getAddressSuggestCorporationsRequest());

    AddressBookApi.getAddressSuggestCorporations(id, data, dispatch)
      .then((response) => {
        dispatch(getAddressSuggestCorporationsSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getAddressSuggestCorporationsFailure(error.response));
      });
  };
}

/*** GET /warning-address/suggest-corp ***/
const getWarningAddressSuggestCorpRequest = () => ({
  type: GET_WARNING_ADDRESS_SUGGEST_CORP_REQUEST,
});

const getWarningAddressSuggestCorpSuccess = (corporations) => ({
  type: GET_WARNING_ADDRESS_SUGGEST_CORP_SUCCESS,
  payload: {
    corporations: corporations
  }
});

const getWarningAddressSuggestCorpFailure = (error) => ({
  type: GET_WARNING_ADDRESS_SUGGEST_CORP_FAILURE,
  payload: {
    error: error
  }
});

export function getWarningAddressSuggestCorp(id, data = {}) {
  return async (dispatch) => {
    dispatch(getWarningAddressSuggestCorpRequest());

    AddressBookApi.getWarningAddressSuggestCorporations(id, data, dispatch)
      .then((response) => {
        dispatch(getWarningAddressSuggestCorpSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getWarningAddressSuggestCorpFailure(error.response));
      });
  };
}

/*** GET /error-address/suggest-corp ***/
const getErrorAddressSuggestCorpRequest = () => ({
  type: GET_ERROR_ADDRESS_SUGGEST_CORP_REQUEST,
});

const getErrorAddressSuggestCorpSuccess = (corporations) => ({
  type: GET_ERROR_ADDRESS_SUGGEST_CORP_SUCCESS,
  payload: {
    corporations: corporations
  }
});

const getErrorAddressSuggestCorpFailure = (error) => ({
  type: GET_ERROR_ADDRESS_SUGGEST_CORP_FAILURE,
  payload: {
    error: error
  }
});

export function getErrorAddressSuggestCorp(id, data = {}) {
  return async (dispatch) => {
    dispatch(getErrorAddressSuggestCorpRequest());

    AddressBookApi.getErrorAddressSuggestCorporations(id, data, dispatch)
      .then((response) => {
        dispatch(getErrorAddressSuggestCorpSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getErrorAddressSuggestCorpFailure(error.response));
      });
  };
}

/*** GET /address 紐付け失敗 ***/
const getFailedLinkAddressRequest = () => ({
  type: GET_FAILED_LINK_ADDRESS_REQUEST,
});

const getFailedLinkAddressSuccess = (pageInfo) => ({
  type: GET_FAILED_LINK_ADDRESS_SUCCESS,
  payload: {
    pageInfo: pageInfo,
  }
});

const getFailedLinkAddressFailure = (error) => ({
  type: GET_FAILED_LINK_ADDRESS_FAILURE,
  payload: {
    error: error,
  }
});

export function getFailedLinkAddress() {
  return async (dispatch) => {
    dispatch(getFailedLinkAddressRequest());

    const linkFailureStatus = 3;
    let query = { "link_corporation_status": [linkFailureStatus], "paging": 1, "per_page": 1, "page": 1 };

    AddressBookApi.getAddress(query, dispatch)
      .then((response) => {
        dispatch(getFailedLinkAddressSuccess(response.data.meta));
      })
      .catch((error) => {
        dispatch(getFailedLinkAddressFailure(error.response));
      });
  };
}

/*** PUT /address/corporation/updateMulti ***/
const putAddressLinkCorporationRequest = () => ({
  type: PUT_ADDRESS_LINK_CORPORATION_REQUEST,
});

const putAddressLinkCorporationSuccess = () => ({
  type: PUT_ADDRESS_LINK_CORPORATION_SUCCESS,
});

const putAddressLinkCorporationFailure = (error) => ({
  type: PUT_ADDRESS_LINK_CORPORATION_FAILURE,
  payload: {
    error: error,
  }
});

export function putAddressLinkCorporation(data) {
  return async (dispatch) => {
    dispatch(putAddressLinkCorporationRequest());

    AddressBookApi.putAddressLinkCorporation(data, dispatch)
      .then(() => {
        dispatch(putAddressLinkCorporationSuccess());
      })
      .catch((error) => {
        dispatch(putAddressLinkCorporationFailure(error.response.data));
      });
  };
}

/***
*  POST /warning-addresses/{id}/save-with-executive-person
***/
const postWarningAddressWithExecutivePersonRequest = () => ({
  type: POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_REQUEST,
});

const postWarningAddressWithExecutivePersonSuccess = () => ({
  type: POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_SUCCESS,
});

const postWarningAddressWithExecutivePersonFailure = (errors) => ({
  type: POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_FAILURE,
  payload: {
    error: errors
  }
});

export function postWarningAddressWithExecutivePerson(id, isReferExecutivePerson) {
  return async (dispatch) => {
    dispatch(postWarningAddressWithExecutivePersonRequest());

    AddressBookApi.postWarningAddressWithExecutivePerson(id, isReferExecutivePerson, dispatch)
      .then(() => {
        dispatch(postWarningAddressWithExecutivePersonSuccess());
      })
      .catch((errors) => {
        dispatch(postWarningAddressWithExecutivePersonFailure(errors.response));
      });
  };
}


/***
*  POST /warning-addresses/{id}/overwrite
***/
const postWarningAddressOverwriteRequest = () => ({
  type: POST_WARNING_ADDRESSES_OVERWRITE_REQUEST,
});

const postWarningAddressOverwriteSuccess = () => ({
  type: POST_WARNING_ADDRESSES_OVERWRITE_SUCCESS,
});

const postWarningAddressOverwriteFailure = (errors) => ({
  type: POST_WARNING_ADDRESSES_OVERWRITE_FAILURE,
  payload: {
    error: errors,
  }
});

export function postWarningAddressOverwrite(id) {
  return async (dispatch) => {
    dispatch(postWarningAddressOverwriteRequest());

    AddressBookApi.postWarningAddressOverwrite(id, dispatch)
      .then(() => {
        dispatch(postWarningAddressOverwriteSuccess());
        //dispatch(getWarningAddress({'paging': 1, 'page': 1, 'per_page': ADDRESS_PER_PAGE}, true));
      })
      .catch((errors) => {
        dispatch(postWarningAddressOverwriteFailure(errors.response));
      });
  };
}

/***
*  各タブのトータル件数を取得するため
***/
const getAddressTotalsRequest = () => ({
  type: GET_ADDRESS_TOTALS_REQUEST,
});

const getAddressTotalsSuccess = (totals) => ({
  type: GET_ADDRESS_TOTALS_SUCCESS,
  payload: {
    totals: totals
  }
});

const getAddressTotalsFailure = (errors) => ({
  type: GET_ADDRESS_TOTALS_FAILURE,
  payload: {
    error: errors,
  }
});

export function getAddressTotals() {
  let query = { 'paging': 1, 'page': 1, 'per_page': 1 };

  return async (dispatch) => {
    dispatch(getAddressTotalsRequest());
    Promise.all([
      AddressBookApi.getAddress(query, dispatch),
      AddressBookApi.getWarningAddress(query, dispatch),
      AddressBookApi.getErrorAddress(query, dispatch),
      NgSendingsApi.getNgSendings({ ...query }, dispatch),
    ])
      .then((responses) => {
        let totals = {};
        for (let i in responses) {
          if (responses[i].data.meta && responses[i].data.meta.path) {
            let meta = responses[i].data.meta;
            if (meta.path.includes('warning-addresses')) {
              totals['totalWarningAddresses'] = meta.total;
            } else if (meta.path.includes('error-addresses')) {
              totals['totalErrorAddresses'] = meta.total;
            } else if (meta.path.includes('ng-sendings')) {
              totals['totalNgList'] = meta.total;
            } else {
              totals['totalAddresses'] = meta.total;
            }
          }
        }
        dispatch(getAddressTotalsSuccess(totals));
      })
      .catch((errors) => {
        dispatch(getAddressTotalsFailure(errors));
      });
  };
}

/*** POST /addresses/move-ng-sendings ***/
const postAddressesMoveNgSendingsRequest = () => ({
  type: POST_ADDRESSES_MOVE_NG_SENDINGS_REQUEST,
});

const postAddressesMoveNgSendingsSuccess = (prevItem, message) => ({
  type: POST_ADDRESSES_MOVE_NG_SENDINGS_SUCCESS,
  payload: {
    prevItem: prevItem,
    message: message
  }
});

const postAddressesMoveNgSendingsFailure = (error) => ({
  type: POST_ADDRESSES_MOVE_NG_SENDINGS_FAILURE,
  payload: {
    error: error
  }
});

export function postAddressesMoveNgSendings(data) {
  return async (dispatch) => {
    dispatch(postAddressesMoveNgSendingsRequest());

    AddressBookApi.postAddressesMoveNgSendings(data, dispatch)
      .then((response) => {
        dispatch(postAddressesMoveNgSendingsSuccess(data, response.data.message));
      })
      .catch((error) => {
        dispatch(postAddressesMoveNgSendingsFailure(error.response.data));
      });
  };
}

/*** POST /addresses/restore-ng-sendings ***/
const postAddressesRestoreNgSendingsRequest = () => ({
  type: POST_ADDRESSES_RESTORE_NG_SENDINGS_REQUEST,
});

const postAddressesRestoreNgSendingsSuccess = () => ({
  type: POST_ADDRESSES_RESTORE_NG_SENDINGS_SUCCESS,
});

const postAddressesRestoreNgSendingsFailure = (error) => ({
  type: POST_ADDRESSES_RESTORE_NG_SENDINGS_FAILURE,
  payload: {
    error: error
  }
});

export function postAddressesRestoreNgSendings(data) {
  return async (dispatch) => {
    dispatch(postAddressesRestoreNgSendingsRequest());

    AddressBookApi.postAddressesRestoreNgSendings(data, dispatch)
      .then(() => {
        dispatch(postAddressesRestoreNgSendingsSuccess());
      })
      .catch((error) => {
        dispatch(postAddressesRestoreNgSendingsFailure(error.response));
      });
  };
}

/*** /executive_list GET ***/
const getExecutiveListCountRequest = () => ({
  type: GET_EXECUTIVE_LIST_COUNT_REQUEST,
});

const getExecutiveListCountSuccess = (pageInfo) => ({
  type: GET_EXECUTIVE_LIST_COUNT_SUCCESS,
  payload: {
    pageInfo: pageInfo,
  }
});

const getExecutiveListCountFailure = (error) => ({
  type: GET_EXECUTIVE_LIST_COUNT_FAILURE,
  payload: {
    error: error
  }
});

export const getExecutiveListCount = (data) => {
  return (dispatch) => {
    dispatch(getExecutiveListCountRequest());

    ExecutiveListApi.getExecutiveList(data, dispatch)
      .then((response) => {
        dispatch(getExecutiveListCountSuccess(
          response.data.meta,
        ));
      })
      .catch((error) => {
        dispatch(getExecutiveListCountFailure(error.response.data));
      });
  };
}

/*** PUT /addresses/tags/deletemulti ***/
const putAddressesTagsDeleteMultiRequest = () => ({
  type: PUT_ADDRESSES_TAGS_DELETEMULTI_REQUEST,
});

const putAddressesTagsDeleteMultiSuccess = () => ({
  type: PUT_ADDRESSES_TAGS_DELETEMULTI_SUCCESS,
});

const putAddressesTagsDeleteMultiFailure = (error) => ({
  type: PUT_ADDRESSES_TAGS_DELETEMULTI_FAILURE,
  payload: {
    error: error
  }
});

export function putAddressesTagsDeleteMulti(data) {
  return async (dispatch) => {
    dispatch(putAddressesTagsDeleteMultiRequest());

    AddressBookApi.putAddressesTagsDeleteMulti(data, dispatch)
      .then(() => {
        dispatch(putAddressesTagsDeleteMultiSuccess());
      })
      .catch((error) => {
        dispatch(putAddressesTagsDeleteMultiFailure(error.response));
      });
  };
}

/*** PUT /addresses/tags/updateTagNameMulti ***/
const putAddressesTagsUpdateTagNameMultiRequest = () => ({
  type: PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST,
});

const putAddressesTagsUpdateTagNameMultiSuccess = () => ({
  type: PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS,
});

const putAddressesTagsUpdateTagNameMultiFailure = (error) => ({
  type: PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE,
  payload: {
    error: error
  }
});

export function putAddressesTagsUpdateTagNameMulti(data) {
  return async (dispatch) => {
    dispatch(putAddressesTagsUpdateTagNameMultiRequest());

    AddressBookApi.putAddressesTagsUpdateTagNameMulti(data, dispatch)
      .then(() => {
        dispatch(putAddressesTagsUpdateTagNameMultiSuccess());
      })
      .catch((error) => {
        dispatch(putAddressesTagsUpdateTagNameMultiFailure(error.response));
      });
  };
}

/*** PUT /warning-addresses/tags/deletemulti ***/
const putWarningAddressesTagsDeleteMultiRequest = () => ({
  type: PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_REQUEST,
});

const putWarningAddressesTagsDeleteMultiSuccess = () => ({
  type: PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_SUCCESS,
});

const putWarningAddressesTagsDeleteMultiFailure = (error) => ({
  type: PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_FAILURE,
  payload: {
    error: error
  }
});

export function putWarningAddressesTagsDeleteMulti(data) {
  return async (dispatch) => {
    dispatch(putWarningAddressesTagsDeleteMultiRequest());

    AddressBookApi.putWarningAddressesTagsDeleteMulti(data, dispatch)
      .then(() => {
        dispatch(putWarningAddressesTagsDeleteMultiSuccess());
      })
      .catch((error) => {
        dispatch(putWarningAddressesTagsDeleteMultiFailure(error.response));
      });
  };
}

/*** PUT /warning-addresses/tags/updatetagnamemulti ***/
const putWarningAddressesTagsUpdateTagNameMultiRequest = () => ({
  type: PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST,
});

const putWarningAddressesTagsUpdateTagNameMultiSuccess = () => ({
  type: PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS,
});

const putWarningAddressesTagsUpdateTagNameMultiFailure = (error) => ({
  type: PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE,
  payload: {
    error: error
  }
});

export function putWarningAddressesTagsUpdateTagNameMulti(data) {
  return async (dispatch) => {
    dispatch(putWarningAddressesTagsUpdateTagNameMultiRequest());

    AddressBookApi.putWarningAddressesTagsUpdateTagNameMulti(data, dispatch)
      .then(() => {
        dispatch(putWarningAddressesTagsUpdateTagNameMultiSuccess());
      })
      .catch((error) => {
        dispatch(putWarningAddressesTagsUpdateTagNameMultiFailure(error.response));
      });
  };
}

/*** PUT /error-addresses/tags/deletemulti ***/
const putErrorAddressesTagsDeleteMultiRequest = () => ({
  type: PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_REQUEST,
});

const putErrorAddressesTagsDeleteMultiSuccess = () => ({
  type: PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_SUCCESS,
});

const putErrorAddressesTagsDeleteMultiFailure = (error) => ({
  type: PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_FAILURE,
  payload: {
    error: error
  }
});

export function putErrorAddressesTagsDeleteMulti(data) {
  return async (dispatch) => {
    dispatch(putErrorAddressesTagsDeleteMultiRequest());

    AddressBookApi.putErrorAddressesTagsDeleteMulti(data, dispatch)
      .then(() => {
        dispatch(putErrorAddressesTagsDeleteMultiSuccess());
      })
      .catch((error) => {
        dispatch(putErrorAddressesTagsDeleteMultiFailure(error.response));
      });
  };
}

/*** PUT /error-addresses/tags/updatetagnamemulti ***/
const putErrorAddressesTagsUpdateTagNameMultiRequest = () => ({
  type: PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST,
});

const putErrorAddressesTagsUpdateTagNameMultiSuccess = () => ({
  type: PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS,
});

const putErrorAddressesTagsUpdateTagNameMultiFailure = (error) => ({
  type: PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE,
  payload: {
    error: error
  }
});

export function putErrorAddressesTagsUpdateTagNameMulti(data) {
  return async (dispatch) => {
    dispatch(putErrorAddressesTagsUpdateTagNameMultiRequest());

    AddressBookApi.putErrorAddressesTagsUpdateTagNameMulti(data, dispatch)
      .then(() => {
        dispatch(putErrorAddressesTagsUpdateTagNameMultiSuccess());
      })
      .catch((error) => {
        dispatch(putErrorAddressesTagsUpdateTagNameMultiFailure(error.response));
      });
  };
}

/*** POST /address-corporation-differences/verify ***/
const postAddressCorporationDifferencesVerifyRequest = () => ({
  type: POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_REQUEST,
});

const postAddressCorporationDifferencesVerifySuccess = () => ({
  type: POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_SUCCESS,
  payload: {
  }
});

const postAddressCorporationDifferencesVerifyFailure = (error) => ({
  type: POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_FAILURE,
  payload: {
    error: error
  }
});

export function postAddressCorporationDifferencesVerify(data) {
  return async (dispatch) => {
    dispatch(postAddressCorporationDifferencesVerifyRequest());

    AddressCorporationDifferencesApi.postAddressCorporationDifferencesVerify(data, dispatch)
      .then(() => {
        dispatch(postAddressCorporationDifferencesVerifySuccess());
        dispatch(getAddressCorporationDifferencesCount());
      })
      .catch((error) => {
        dispatch(postAddressCorporationDifferencesVerifyFailure(error.response));
      });
  };
}

/*** GET /address-corporation-differences/count ***/
const getAddressCorporationDifferencesCountRequest = () => ({
  type: GET_ADDRESS_CORPORATION_DIFFERENCES_COUNT_REQUEST,
});

const getAddressCorporationDifferencesCountSuccess = (count) => ({
  type: GET_ADDRESS_CORPORATION_DIFFERENCES_COUNT_SUCCESS,
  payload: {
    count: count,
  }
});

const getAddressCorporationDifferencesCountFailure = (error) => ({
  type: GET_ADDRESS_CORPORATION_DIFFERENCES_COUNT_FAILURE,
  payload: {
    error: error
  }
});

export function getAddressCorporationDifferencesCount() {
  return async (dispatch) => {
    dispatch(getAddressCorporationDifferencesCountRequest());

    AddressCorporationDifferencesApi.getAddressCorporationDifferencesCount(dispatch)
      .then((response) => {
        dispatch(getAddressCorporationDifferencesCountSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getAddressCorporationDifferencesCountFailure(error.response));
      });
  };
}

/*** POST /address-corporation-differences/update-difference ***/
const postAddressCorporationDifferencesUpdateDifferenceRequest = () => ({
  type: POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_REQUEST,
});

const postAddressCorporationDifferencesUpdateDifferenceSuccess = () => ({
  type: POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_SUCCESS,
  payload: {
  }
});

const postAddressCorporationDifferencesUpdateDifferenceFailure = (error) => ({
  type: POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_FAILURE,
  payload: {
    error: error
  }
});

export function postAddressCorporationDifferencesUpdateDifference(data) {
  return async (dispatch) => {
    dispatch(postAddressCorporationDifferencesUpdateDifferenceRequest());

    AddressCorporationDifferencesApi.postAddressCorporationDifferencesUpdateDifference(data, dispatch)
      .then(() => {
        dispatch(postAddressCorporationDifferencesUpdateDifferenceSuccess());
      })
      .catch((error) => {
        dispatch(postAddressCorporationDifferencesUpdateDifferenceFailure(error.response));
      });
  };
}

/*** POST /warning-addresses/overwritemulti ***/
const postWarningAddressesOverwritemultiRequest = () => ({
  type: POST_WARNING_ADDRESSES_OVERWRITEMULTI_REQUEST,
});

const postWarningAddressesOverwritemultiSuccess = (items) => ({
  type: POST_WARNING_ADDRESSES_OVERWRITEMULTI_SUCCESS,
  payload: {
    addresses: items,
    warnings: [],
    errors: [],
  }
});

const postWarningAddressesOverwritemultiFailure = (error) => ({
  type: POST_WARNING_ADDRESSES_OVERWRITEMULTI_FAILURE,
  payload: {
    error: error
  }
});

export function postWarningAddressesOverwritemulti(data) {
  return async (dispatch) => {
    dispatch(postWarningAddressesOverwritemultiRequest());

    AddressBookApi.postWarningAddressesOverwritemulti(data, dispatch)
      .then((response) => {
        dispatch(postWarningAddressesOverwritemultiSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(postWarningAddressesOverwritemultiFailure(error.response));
      });
  };
}

/*** POST /warning_addresses ***/
const postWarningAddressesMultiRequest = () => ({
  type: POST_WARNING_ADDRESSES_MULTI_REQUEST,
});

const postWarningAddressesMultiSuccess = (addresses, warnings, errors) => ({
  type: POST_WARNING_ADDRESSES_MULTI_SUCCESS,
  payload: {
    addresses: addresses,
    warnings: warnings,
    errors: errors,
  }
});

const postWarningAddressesMultiFailure = (error) => ({
  type: POST_WARNING_ADDRESSES_MULTI_FAILURE,
  payload: {
    error: error
  }
});

export function postWarningAddressesMulti(data) {
  return async (dispatch) => {
    dispatch(postWarningAddressesMultiRequest());

    AddressBookApi.postWarningAddressesMulti(data, dispatch)
      .then((response) => {
        dispatch(postWarningAddressesMultiSuccess(
          response.data.data.addresses,
          response.data.data.warning_addresses,
          response.data.data.error_addresses,
        ));
      })
      .catch((error) => {
        dispatch(postWarningAddressesMultiFailure(error.response));
      });
  };
}

export const storeFilterValue = (data) => ({
  type: STORE_FILTER_VALUE,
  payload: {
    filterValue: data,
  }
});

/*** POST /addresses/salesforce/sync ***/
const postSalesforceSyncRequest = () => ({
  type: POST_ADDRESS_LIST_SALESFORCE_SYNC_REQUEST,
});

const postSalesforceSyncSuccess = (data) => ({
  type: POST_ADDRESS_LIST_SALESFORCE_SYNC_SUCCESS,
  payload: {
    message: data.message,
    data: data.data,
  },
});

const postSalesforceSyncFailure = (error) => ({
  type: POST_ADDRESS_LIST_SALESFORCE_SYNC_FAILURE,
  payload: {
    error: error,
  },
});

export function postSalesforceSync() {
  return async (dispatch) => {
    dispatch(postSalesforceSyncRequest());

    AddressBookApi.postSalesforceSync(null, dispatch)
      .then((response) => {
        dispatch(postSalesforceSyncSuccess(response.data));
      })
      .catch((error) => {
        dispatch(postSalesforceSyncFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/AddressBook.js